import React, { useState, useEffect, useRef, ReactNode } from 'react';
import { Navigation, A11y, Thumbs } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import EVImg from '@components/EVImg/EVImg';
import {
  CarouselNavButtonLeft,
  CarouselNavButtonRight,
} from '@components/MiscComponents/GridAndCarouselComponents';

import { ImagesWrapper } from './styles';

export interface ImageGalleryProps {
  imagesArr: string[];
  thumbsSwiper: any;
  setImagesSwiper: (swiper: any) => void;
}

export const GalleryImages = ({
  imagesArr,
  thumbsSwiper,
  setImagesSwiper,
}: ImageGalleryProps): ReactNode => {
  // Images navigation buttons
  const imagesPrevRef = useRef(null);
  const imagesNextRef = useRef(null);

  return (
    <ImagesWrapper>
      <Swiper
        modules={[Navigation, A11y, Thumbs]}
        spaceBetween={0}
        slidesPerView={1}
        navigation={{
          prevEl: imagesPrevRef.current,
          nextEl: imagesNextRef.current,
        }}
        onSwiper={setImagesSwiper}
        thumbs={{ swiper: thumbsSwiper }}
      >
        {imagesArr &&
          imagesArr.length > 0 &&
          imagesArr.map((image, index) => {
            return (
              <SwiperSlide key={index}>
                <EVImg
                  className="image-large"
                  dataTestId={`property-image-${index}`}
                  src={image}
                  sizes={['100vw', '100vw', '100vw', '1272px']}
                  priority={index === 0 ? true : false}
                  quality={100}
                  unoptimized
                />
              </SwiperSlide>
            );
          })}
        <CarouselNavButtonLeft ref={imagesPrevRef} variant="dark" className="swiper-button-prev" />
        <CarouselNavButtonRight ref={imagesNextRef} variant="dark" className="swiper-button-next" />
      </Swiper>
    </ImagesWrapper>
  );
};

export default GalleryImages;
